import React, { useState } from 'react';
import { Button, useDeleteMany, useRefresh } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { useRedirect, useTranslate } from 'ra-core';
import { ConfirmDialog } from '../ui/ConfirmDialog';
import { useLayer7Notify } from '../useLayer7Notify';

const BulkResetViewsButton = props => {
    const records = props.selectedIds ?? [props.record?.id];
    const [open, setOpen] = useState(false);
    const notify = useLayer7Notify();
    const translate = useTranslate();
    const refresh = useRefresh();
    const redirect = useRedirect();
    const classes = useStyles(props);

    const [remove] = useDeleteMany('users', records, {
        onSuccess: () => {
            setOpen(false);
            if (props.selectedIds)
                document.querySelector('[title="Unselect"').click();
            notify('resources.users.notifications.delete_success', 'info', {
                smart_count: 1,
            });
            if (props.selectedIds) refresh();
            else redirect('/users');
        },
        onFailure: error => {
            setOpen(false);
            if (props.selectedIds)
                document.querySelector('[title="Unselect"').click();
            notify(
                error || 'resources.users.notifications.delete_error',
                'error'
            );
        },
    });

    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);
    const handleConfirm = () => {
        remove();
        setOpen(false);
    };

    return (
        <>
            <Button
                label="delete"
                onClick={handleClick}
                className={classes.button}
            />
            <ConfirmDialog
                open={open}
                onConfirm={handleConfirm}
                onCancel={handleDialogClose}
                title={translate('resources.users.actions.deleteUser')}
                content={translate(
                    'resources.users.notifications.confirm_delete'
                )}
                buttonConfirm={translate('resources.users.actions.confirm')}
                buttonCancel={translate('resources.users.actions.cancel')}
            />
        </>
    );
};

const useStyles = makeStyles(theme => ({
    button: {
        float: 'right',
        color: 'red',
    },
}));

export { BulkResetViewsButton };
